import React, { Component, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Loading from './components/ui/feedback/Loader';
import { verifyJWT } from './redux/auth';
import './App.css';
import TermsOfService from './components/legal/TermsOfService';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import ResetPasswordByKey from './components/ResetPasswordByKey';
import { AxiosErrorHandlerComp } from './axios';

const Home = lazy(() => import('./components/Home'));
const LoginPage = lazy(() => import('./components/login'));

class App extends Component {
  render() {
    return (
      <Suspense fallback={<Loading />}>
        <AxiosErrorHandlerComp>
          <Switch>
            <Route
              path='/login'
              render={() => {
                if (this.props.isAuthenticate === undefined) {
                  this.props.verifyJWT();
                  return null;
                } else if (this.props.isAuthenticate) {
                  return <Redirect to='/' />;
                } else {
                  return <LoginPage />;
                }
              }}
            />
            <Route path='/terms-of-service' component={TermsOfService} />
            <Route path='/privacy-policy' component={PrivacyPolicy} />
            <Route path='/reset-password-by-key' component={ResetPasswordByKey} />
            <Route
              path='/request-reset-password-email'
              render={() => {
                return <LoginPage subComponent='request-reset-password' />;
              }}
            />
            <Route
              path='/'
              render={() => {
                if (this.props.isAuthenticate === undefined) {
                  this.props.verifyJWT();
                  return null;
                } else if (this.props.isAuthenticate) {
                  return <Home />;
                } else return <Redirect to='/login' />;
              }}
            />
          </Switch>
        </AxiosErrorHandlerComp>
      </Suspense>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticate: state.auth.isAuthenticate,
    isRequiredChangePassword: state.auth.isRequiredChangePassword,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    verifyJWT: () => dispatch(verifyJWT()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
